import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function getSurvey() { return axios.post(`${base.url}/business/questionConfig/getSurvey`) }
